export default __webpack_public_path__ + "static/media/alliance_im11.32411c25.png";